import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

import { LogService } from './log.service';

@Injectable({
    providedIn: 'root'
})
export class StorageService
{
    private _storage: Storage | null = null;

    constructor(
        private storage: Storage,
        private log: LogService
    )
    {
    }

    async initDb()
    {
        if (this._storage == null) {
            this._storage = await this.storage.create();
        }
    }

    async setData(key, val)
    {
        await this.initDb();

        await this._storage.set(key, val)
          .then(() => {
                this.log.debug(`StorageService -> setData success: ${key}`);
          })
          .catch((err) => {
                this.log.error(['error', err]);
                this.log.error(`StorageService -> setData failure: ${key}`);
          });
    }

    async getData(key)
    {
        await this.initDb();

        return await this._storage.get(key)
          .then((data) => {
                return data;
          })
          .catch((err) => {
                this.log.error(['error', err]);
                this.log.debug(`StorageService -> getData failure: ${key}`);
                return null;
          });
    }

    async remove(key)
    {
        await this.initDb();

        await this._storage.remove(key)
          .then(() => {
                this.log.debug("StorageService -> remove success");
          })
          .catch((err) => {
                this.log.error(['error', err]);
                this.log.error("StorageService -> remove failure");
          });
    }

    async getKeys()
    {
        await this.initDb();

        return await this._storage.keys()
          .then((keys) => {
                this.log.debug("StorageService -> keys success");
                return keys;
          })
          .catch((err) => {
                this.log.error(['error', err]);
                this.log.error("StorageService -> keys failure");
                return null;
          });
    }

    async delete()
    {
        await this.initDb();

        await this._storage.clear()
          .then(() => {
                this.log.debug("StorageService -> delete success");
          })
          .catch((err) => {
                this.log.error(['error', err]);
                this.log.error("StorageService -> delete failure");
          });
    }
}
